export enum WirePartyType {
  Driver = 'Driver', // Main driver
  PolicyHolder = 'PolicyHolder',
  Individual = 'Individual',
  AdditionalPolicyHolder = 'AdditionalPolicyHolder',
  AdditionalDriver = 'AdditionalDriver',
  Other = 'Other',
  Unknown = 'Unknown',
  Company = 'Company',
}

export enum WireGender {
  Male = 'Male',
  Female = 'Female',
  Unknown = 'Unknown',
  NA = 'NA',
}

export enum WirePolicyRole {
  PrimaryPolicyHolder = 'PrimaryPolicyHolder',
  PolicyHolder = 'PolicyHolder',
  NotApplicable = 'NotApplicable',
}

export type WireClaims = {
  last3Years: string;
};

export type WirePartyBase = {
  id: string;
  addressRefId: string[];
  type: WirePartyType;
  name: string;
  lastName: string;
  firstName: string;
  middleName: string;
  dob: string; // date format YYYY-MM-DD
  gender: WireGender;
  role: WirePolicyRole;
  email?: string;
  mobile?: string;
};

export type WireParty = WirePartyBase & {
  abn: string;
  claims: WireClaims;
  numberOfYearsInsured: string;
  company?: string;
  isTaxExempted?: boolean;
};
